import { Fragment } from 'react';

import { useApiGet } from '../../common/api/Api.hooks';
import { EntitySchema, RelationshipSchema } from './types';

export interface EntityProperty {
  schema?: EntitySchema;
  propertyName?: string;
  relation?: RelationshipSchema;
}

export function getEntityProperties(
  propertyNames: (string | undefined)[] = [],
  schema: EntitySchema | undefined,
  schemas: EntitySchema[]
) {
  const [propertyName, ...relations] = propertyNames;
  const properties: EntityProperty[] = [
    {
      schema,
      propertyName,
      relation: schema?.relations?.find(
        relation => relation.propertyName === propertyName
      )
    }
  ];
  for (const propertyName of relations) {
    // get entitySchema and relation based on previous property
    const previous = properties[properties.length - 1];
    const schema = schemas.find(
      schema => schema.name === previous.relation?.target
    );
    properties.push({
      schema,
      propertyName,
      relation: schema?.relations?.find(
        relation => relation.propertyName === propertyName
      )
    });
  }
  return properties;
}

export function displayEntityProperties(properties: EntityProperty[]) {
  return properties.map((property, index) => {
    return (
      <Fragment key={index}>
        <strong>{property.relation?.displayName || '?'}</strong>
        {index < properties.length - 1 && ' -> '}
      </Fragment>
    );
  });
}

export function useFindEntitySchemas() {
  const { data, isLoading, error, get } = useApiGet<EntitySchema[]>(
    'tasks/entity-schemas'
  );
  return {
    entitySchemas: data,
    isLoading,
    error,
    findEntitySchemas: get
  };
}
